import { useMemo } from 'react'
import { useChatContext } from 'react-common'
import { useTranslation } from 'react-i18next'
import { API_BASE } from 'apps-common'
import { useAppSelector } from '@/store/hooks'
import { CustomTreeNode } from '@/store/slices/layoutSlice'
import { COURSE_CHAT_SLUG } from '@/views/courses/ActivityTypes/hooks/useSetCourseSidebarLayers'

export const useNotificationIndicatorSidebarItem = () => {
  const { t } = useTranslation()
  const { openChatWindow, getUnreadCountByChannelId } = useChatContext()
  const objective = useAppSelector((state) => state.aggregate.current?.objective)

  const unreadCount = getUnreadCountByChannelId(objective?.announcementChannelId!)

  return useMemo(() => {
    // All objectives have announcementChannelId property
    // However, there still may be a time gap between the moments when the feature is activated and when the announcement channel is created for the objective.
    if (!objective?.announcementChannelId) return {} as CustomTreeNode

    return {
      name: t('resourcesWizard.notifications'),
      url: COURSE_CHAT_SLUG, // this URL is necessary for styling of ToggleButton etc.
      slug: COURSE_CHAT_SLUG,
      icon_id: 'NotificationBoldStroke',
      onClick: (e: any) => {
        e.preventDefault()
        const channelUrl = `${window.location.protocol}${window.location.host}${API_BASE.PLATFORM}chat/channels/groups/${objective?.announcementChannelId}`

        openChatWindow(channelUrl)
      },
      badge: !!unreadCount ? `${unreadCount}` : undefined,
    } as CustomTreeNode
  }, [t, unreadCount, openChatWindow, objective?.announcementChannelId])
}
